<template>
    <el-dialog :close-on-click-modal="false"
               v-bind="$attrs"
               v-on="$listeners"
               title="回退派工"
               @open="open"
               @closed="closed"
               width="700px">
      <div style="margin: 0 30px 0 30px" :key="pattern">
        <el-form label-position="right" label-width="100px">
          <div style="display: flex">
            <div style="flex-grow: 1">
              <el-form-item label="工单号">
                <label class="value">{{work.extraId || work.id}}</label>
              </el-form-item>
              <el-form-item label="品牌/车系">
                <label class="value">{{work.brandName}} / {{work.model}}</label>
              </el-form-item>
              <el-form-item label="当前技师">
                <label class="value">{{work.technicianName}}</label>
              </el-form-item>
              <el-form-item label="车辆颜色">
                <label class="value" :style="{'width':'130px', 'background-color': work.color,'display':'block'}">{{work.color === 'white' ? '白' : '&nbsp;'}}</label>
              </el-form-item>
            </div>
            <div style="flex-grow: 1">
              <el-form-item label="车牌号">
                <label class="value">{{work.carNo | carNo}}</label>
              </el-form-item>
              <el-form-item label-width="100px" label="交车时间">
                <label class="value">{{work.estimateDeliveryTime}}</label>
              </el-form-item>
              <el-form-item label="当前工序">
                <div v-for="item in dispatchProcedureList" :key="item.id">
                    <label class="value"  v-if="item.id===work.procedureId">{{item.name}}</label>
                </div>
              </el-form-item>
              <el-form-item label="是否加急">
                <label class="value">{{work.urgent ? '是' : '否'}}</label>
              </el-form-item>
            </div>
          </div>
        </el-form>

        <el-form label-position="right" label-width="100px" :model="request" :rules="rules" ref="request" style="display: flex;">
          <div style="flex-grow: 1">
            <el-form-item label="工单状态" prop="workStatus">
              <remote-select :options="backWorkState" v-model="request.workStatus" usingCode></remote-select>
            </el-form-item>
            <el-form-item label="回退工序" prop="procedureId" v-if="request.workStatus!=='WAIT_CONFIRM'&&request.workStatus!==null">
              <remote-select :options="dispatchProcedureList" v-model="request.procedureId"></remote-select>
            </el-form-item>
          </div>
          <div style="flex-grow: 1">
            <el-form-item label="回退原因" prop="reasonId">
              <remote-select class-name="FALL_BACK_REASON" v-model="request.reasonId"></remote-select>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <template #footer>
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </template>
    </el-dialog>
  </template>

  <script>
    import RemoteSelect from '@/components/selector/RemoteSelect'
    import { fallBack, dispatchWorkProcedures } from '@/utils/request'

    export default {
      name: 'InterruptWorkDialog',
      components: { RemoteSelect },
      props: {
        pattern: {
          type: String, // INTERRUPT, MACHINE_REPAIR
          required: true
        },
        work: {
          type: Object,
          required: true
        }
      },
      data () {
        return {
          request: {
            workId: null,
            workStatus: null,
            reasonId: null,
            procedureId: null
          },
          rules: {
            procedureId: [
              {
                required: true,
                message: '请选择需要回退到的工序',
                trigger: 'change'
              }
            ],
            reasonId: [
              {
                required: true,
                message: '请选择回退原因',
                trigger: 'change'
              }
            ],
            workStatus: [
              {
                required: true,
                message: '请选择回退时工单的状态',
                trigger: 'change'
              }
            ]
          },
          loading: false,
          dispatchProcedureList: [],
          backWorkState: []
        }
      },
      methods: {
        open () {
            this.loading = true
            dispatchWorkProcedures(this.work.id).then(response => {
                this.dispatchProcedureList = response.data
            }).finally(() => {
              this.loading = false
            })
            this.backWorkState = [{ id: '1', code: 'WAIT_CONFIRM', name: '等待确认' }, { id: '2', code: 'WAIT', name: '待施工' }, { id: '3', code: 'RUN', name: '施工中' }]
        },
        closed () {
          this.request.workId = null
          this.request.workStatus = null
          this.request.reasonId = null
          this.request.procedureId = null
          this.$refs.request.resetFields()
        },
        cancel () {
          this.hide()
        },
        confirm () {
            debugger
          this.$refs.request.validate(valid => {
            if (!valid) return

            this.request.workId = this.work.id
            this.work.loading = true
            fallBack(this.request.workId, this.request.workStatus, this.request.reasonId, this.request.procedureId)
              .then(() => this.hide())
              .catch(() => {
                this.work.loading = false
              })
          })
        },
        hide () {
          this.$emit('update:visible', false)
        }
      },
      computed: {

      }
    }
  </script>

  <style scoped>

  </style>
